module.exports = __webpack_public_path__ + "9c6096eb3aa82dfbb4b275f1d699b983.png";